import { useState, useEffect, useReducer } from 'react'
import { useDispatch } from 'react-redux'
import { Switch, Route, useParams } from 'react-router-dom'

import { clearCities, clearCity } from '@/actions/operations/city'

import { tableReducer, tableInitialState } from './state'

import Area from '../Area'

import Table from './Table'
import Form from './Form'

const MODULE_PATH = '/operations/:zone+/management/countries/regions/cities'

function CityManagement({ organizationId, countryId, regionId, backPath }) {
  const dispatch = useDispatch()

  const params = useParams()

  const [state, dispatchState] = useReducer(tableReducer, tableInitialState)

  const [modulePath, setModulePath] = useState(MODULE_PATH)

  useEffect(() => {
    return () => {
      dispatch(clearCities())
      dispatch(clearCity())
    }
  }, [dispatch])

  useEffect(() => {
    if (params?.zone) {
      setModulePath(MODULE_PATH.replace(':zone+', params.zone))
    }
  }, [params?.zone])

  useEffect(() => {
    if (organizationId && regionId && countryId) {
      dispatchState({
        state: {
          organizations: [organizationId],
          countries: [countryId],
          regions: [regionId]
        }
      })
    }
  }, [organizationId, countryId, regionId])

  return (
    <Switch>
      <Route path={`${MODULE_PATH}/areas`}>
        <Area
          organizationId={state.organizationId}
          countryId={state.countryId}
          regionId={state.regionId}
          cityId={state.cityId}
          backPath={modulePath}
        />
      </Route>
      <Route
        path={[`${MODULE_PATH}/create`, `${MODULE_PATH}/update/:itemId`]}
        exact={true}
      >
        <Form
          state={state}
          dispatchState={dispatchState}
          modulePath={modulePath}
        />
      </Route>
      <Route path={MODULE_PATH} exact={true}>
        <Table
          state={state}
          dispatchState={dispatchState}
          modulePath={modulePath}
          backPath={backPath}
        />
      </Route>
    </Switch>
  )
}

export default CityManagement
